import type { AlchemyType } from '@/domain/genetics/types';
import { elementalMultiplier } from './elemental';

export interface ComputeDamageInput {
  baseDamage: number;
  attackerType: AlchemyType;
  defenderType: AlchemyType;
  critChance: number;   // 0..1
  rng?: () => number;   // default Math.random
  multipliers?: number[]; // bloodlust etc.
}

export interface ComputeDamageOutput {
  damage: number;
  crit: boolean;
  elementalMult: number;
}

const CRIT_MULTIPLIER = 2.0;

export function computeDamage(input: ComputeDamageInput): ComputeDamageOutput {
  const rng = input.rng ?? Math.random;
  const elementalMult = elementalMultiplier(input.attackerType, input.defenderType);
  const crit = rng() < clamp01(input.critChance);
  const critMult = crit ? CRIT_MULTIPLIER : 1.0;
  const extra = (input.multipliers ?? []).reduce((acc, m) => acc * m, 1);
  const dmg = Math.max(0, Math.round(input.baseDamage * elementalMult * critMult * extra));
  return { damage: dmg, crit, elementalMult };
}

function clamp01(v: number): number {
  if (Number.isNaN(v)) return 0;
  return Math.min(1, Math.max(0, v));
}
